import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

export const getPostalCode = async (address) => {
  try {
    const results = await geocodeByAddress(address);
    const postal_code = results[0].address_components.find((component) => component.types.includes('postal_code'));
    if (postal_code) {
      return postal_code.long_name;
    }
    return "";
  } catch (error) {
    return "";
  }
};
export const getCoordinates = async (address) => {
  try {
    const results = await geocodeByAddress(address);
    console.log('Geocode results for address:', address, results);
    const { lat, lng } = await getLatLng(results[0]);
    console.log('Extracted lat/lng:', lat, lng);
    console.log('Coordinates for address:', address, 'are:', lat, lng);
    return { lat, lng };
  } catch (error) {
    console.error('Failed to geocode address:', address, error);
    return { lat: 0, lng: 0 }; // fallback
  }
};
